// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.logo-site[data-v-80cb1e06] {
  background-size: 100%;
}
[data-v-80cb1e06] .picture-accommodation {
  aspect-ratio: unset;
  height: 100%;
}
.detail-collapse[data-v-80cb1e06] {
  display: grid;
  grid-template-rows: 0fr;
  padding: 0;
  transition:
    grid-template-rows 0.3s ease,
    padding 0.3s ease;
}
.detail-collapse.open[data-v-80cb1e06] {
  grid-template-rows: 1fr;
  padding-top: 8px;
  padding-bottom: 8px;
}
.detail-collapse-inner[data-v-80cb1e06] {
  overflow: hidden;
}
.replyZone[data-v-80cb1e06] textarea {
  height: 200px;
  max-height: 400px;
  min-height: 64px;
  resize: vertical;
  border-radius: 0 !important;
  border-style: none;
  background-color: transparent !important;
  padding: 0px;
  font-size: 16px;
  line-height: 24px;
}
.replyZone[data-v-80cb1e06] textarea::-moz-placeholder {
  font-size: 16px;
  line-height: 24px;
}
.replyZone[data-v-80cb1e06] textarea::placeholder {
  font-size: 16px;
  line-height: 24px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
